const domainToAppInstance: { [key: string]: string } = {
  'soha.rastech.ir': 'telethink',
  'op.rastech.ir': 'outpatient.isf.uni',
};

export default domainToAppInstance;
